// Miles or kilometres for Near You distances (owner, 2026-10-20). By the
// country the keeper is in, not the tank's units: road signs in the UK
// read in miles, and a UK keeper on litres and °C still drives in miles.
const MILE_COUNTRIES = new Set(['US', 'PR', 'GU', 'VI', 'AS', 'MP', 'UM', 'GB', 'IM', 'JE', 'GG']);

// 'mi' | 'km' for an ISO country code, null when there is none to go by
// (no header, Cloudflare's XX / T1).
export function distanceUnitForCountry(cc) {
  const c = String(cc || '')
    .trim()
    .toUpperCase();
  if (!/^[A-Z]{2}$/.test(c) || c === 'XX' || c === 'T1') return null;
  return MILE_COUNTRIES.has(c) ? 'mi' : 'km';
}

// The browser's language tag (en-GB, de-DE, en) as the fallback: a tag
// with no country reads as miles, as Near You always did.
export function distanceUnitForLocale(tag) {
  const m = /^[a-z]{2,3}(?:-[A-Za-z]{4})?-([A-Za-z]{2})\b/.exec(String(tag || ''));
  return (m && distanceUnitForCountry(m[1])) || 'mi';
}
